/**
 * Scrolls to a component
 * @param {HTMLElement} elementRef - The element to scroll to
 * @param {object} options - The options for the scroll
 * @param {number} options.offset - The offset to scroll to
 * @param {string} options.align - The alignment of the scroll ('top' or 'bottom')
 * @param {number} options.duration - The duration of the scroll
 */
export function scrollToComponent(elementRef, { offset = 0, align = 'top', duration = 500 } = {}) {
  // Return early if ref is null or undefined
  if (!elementRef) {
    return;
  }

  // Get element's position relative to viewport
  const elementPosition = elementRef.getBoundingClientRect();
  const elementTop = elementPosition.top + window.scrollY;

  // Calculate target scroll position
  let scrollTarget = elementTop;
  if (align === 'bottom') {
    scrollTarget = elementTop + elementPosition.height;
  }
  scrollTarget += offset;

  // Get start position
  const startPosition = window.scrollY;
  const distance = scrollTarget - startPosition;
  let startTime = null;

  // Easing function
  const easeInOutQuad = (t) => {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  };

  // Animation function
  const animation = (currentTime) => {
    if (startTime === null) {
      startTime = currentTime;
    }

    const timeElapsed = currentTime - startTime;
    const progress = Math.min(timeElapsed / duration, 1);
    const easeProgress = easeInOutQuad(progress);

    window.scrollTo(0, startPosition + distance * easeProgress);

    if (timeElapsed < duration) {
      requestAnimationFrame(animation);
    }
  };

  requestAnimationFrame(animation);
}
